<template>
	<div
		class="accordion"
		:class="{
			'is-open': isOpen,
			'is-disabled': disabled,
		}"
	>
		<div
			v-tooltip="headerTooltip"
			class="accordion__header"
			@click="handleAccordionToggle"
		>
			<p class="accordion__title-w">
				<span class="accordion__title">{{ title }}</span>
				<Icon
					v-if="icon"
					v-tooltip="{content: iconHint, classes: 'tooltip'}"
					class="accordion__title-icon"
					:icon-name="icon"
					:inline="true"
				/>
			</p>
			<div class="accordion__toggle-indicator">
				<Icon
					icon-name="down-arrow"
				/>
			</div>
		</div>
		<div
			v-show="isOpen"
			class="accordion__content"
		>
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name:  'Accordion',
	props: {
		title: {
			type:     String,
			required: true,
		},
		icon: {
			type:    String,
			default: null,
		},
		iconHint: {
			type:    String,
			default: null,
		},
		open: {
			type:    Boolean,
			default: false,
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
		disabledHint: {
			type:    String,
			default: null,
		},
	},
	data() {
		return {
			isOpen: false,
		};
	},
	computed: {
		headerTooltip() {
			if (this.disabled && this.disabledHint) {
				return { content: this.disabledHint, classes: 'tooltip' };
			}
			return null;
		},
	},
	watch: {
		open(val) {
			this.isOpen = val;
		},
	},
	created() {
		this.isOpen = !!this.open;
	},
	methods: {
		handleAccordionToggle() {
			if (this.disabled) {
				return;
			}
			this.isOpen = !this.isOpen;
			this.$emit('toggle', this.isOpen);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/fonts';

.accordion {
	display: flex;
	flex-direction: column;
	background: var(--color-grey-900);
	color: var(--color-soft-white);
	border-bottom: 1px solid var(--color-grey-850);

	&.is-disabled {
		color: var(--color-grey-700);
	}
}

.accordion__toggle-indicator {
	transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s;

	.accordion.is-open & {
		transform: rotate(180deg);
	}
}

.accordion__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px #{24px - $scroll-bar-width} 16px 24px;
	user-select: none;

	@media (hover:hover) {
		&:hover {
			cursor: pointer;
		}

		.accordion.is-disabled &:hover {
			cursor: not-allowed;
		}
	}
}

.accordion__title-w {
	@include text-md-2;
	display: flex;
	flex-grow: 1;
	align-items: center;
	gap: $sp4;
}

.accordion__title-icon {
	color: var(--color-grey-300);
}

.accordion__content {
	padding: 16px #{24px - $scroll-bar-width} 16px 24px;
	position: relative;
}
</style>
